import React from 'react';
import { useTheme } from 'styled-components';

interface Props {
  size?: number;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}

// icon-park-twotone:data-three — the empty-state "stacked data disks" illustration, rendered as
// a horizontal ROW of nested disks with the right-hand disk filled (Figma screen-03). Ticket 7127.
export const DataThreeSvg: React.FC<Props> = ({ size = 64, color, style, className }) => {
  const { colors } = useTheme();
  const c = color ?? colors.cflowerBlue;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      {/* outline disks, left → right */}
      <path
        d="M22.667 32.0013C22.667 17.2737 19.0853 5.33463 14.667 5.33463C10.2487 5.33463 6.66699 17.2737 6.66699 32.0013C6.66699 46.7289 10.2487 58.668 14.667 58.668C19.0853 58.668 22.667 46.7289 22.667 32.0013Z"
        stroke={c}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.667 49.6413C22.1337 55.1746 24.2777 58.668 26.667 58.668C31.0857 58.668 34.667 46.7293 34.667 32.0013C34.667 17.2733 31.0857 5.33463 26.667 5.33463C24.2777 5.33463 22.1337 8.82663 20.667 14.3613"
        stroke={c}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.667 49.6413C46.1337 55.1746 48.2777 58.668 50.667 58.668C55.0857 58.668 58.667 46.7293 58.667 32.0013C58.667 17.2733 55.0857 5.33463 50.667 5.33463C48.2777 5.33463 46.1337 8.82663 44.667 14.3613"
        stroke={c}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* filled (gray) disk on the right */}
      <path
        d="M32.667 49.6413C34.1337 55.1746 36.2777 58.668 38.667 58.668C43.0857 58.668 46.667 46.7293 46.667 32.0013C46.667 17.2733 43.0857 5.33463 38.667 5.33463C36.2777 5.33463 34.1337 8.82663 32.667 14.3613C33.911 19.0626 34.667 25.2386 34.667 32.0013C34.667 38.764 33.911 44.9386 32.667 49.6413Z"
        fill={c}
        fillOpacity="0.35"
        stroke={c}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
